// Define the responsive breakpoints as styled-components variables
const responsiveXxxs = '319px';
const responsiveXxs = '413px';
const responsiveXxm = '576px';
const responsiveXs = '767px';
const responsiveSm = '1024px';
const responsiveMd = '1200px';
const responsiveLg = '1350px';
const responsiveLlg = '1875px';

// Define the media queries using styled-components media template literal
export const mobileExtraSmall = `@media (max-width: ${responsiveXxxs})`;
export const mobileSmall = `@media (max-width: ${responsiveXxs})`;
export const mobileMedium = `@media (max-width: ${responsiveXxm})`;
export const mobile = `@media (max-width: ${responsiveXs})`;
export const tabletPortrait = `@media (max-width: ${responsiveSm})`;
export const smallDesktop = `@media (max-width: ${responsiveMd})`;
export const largeDesktop = `@media (max-width: ${responsiveLg})`;
export const extraLargeDesktop = `@media (max-width: ${responsiveLlg})`;
export const retina = `@media (min-resolution: 2dppx)`;

// Define the colors

export const color_grey_17 = '#171e25';
export const color_green_006 = '#006361';
export const color_white = '#ffffff';
export const color_grey_60 = '#606e7b';
export const color_grey_0B = '#0b0c0c';
export const color_yellow_FB = '#FBDD46';
export const color_yellow_FDE = '#fdeeaa;';
export const color_red_error = '#FFD700';
export const color_blue_ss = '#1E8BC2';
export const color_blue_bt = '#014B70';
export const color_blue_1E = '#1A78A8';
export const color_blue_9A = '#9adbfc';
export const color_blue_ED = '#edf6fb';
export const color_blue_014 = '#014b70';
export const color_purple = '#5f2781';
export const color_dim_purple = '#9255b7';
export const color_grey_6D = '#6d7c91';
export const color_blue_1E8 = '#1e8bc2';

//Define the fonts

export const font_montserrat = 'Montserrat, sans-serif';
export const font_nunito = 'Nunito Sans, sans-serif';
